/**
 * Calculate the number of months between two YYYY-MM date strings (inclusive).
 * Example: calculateMonthsDifference('2024-06', '2024-12') returns 7
 * (June, July, August, September, October, November, December)
 */
export function calculateMonthsDifference(
  fromDate: string,
  toDate: string
): number {
  const [fromYear, fromMonth] = fromDate.split('-').map(Number)
  const [toYear, toMonth] = toDate.split('-').map(Number)

  const months = (toYear - fromYear) * 12 + (toMonth - fromMonth) + 1
  return months
}

/**
 * Check if toDate is before fromDate (invalid date range)
 */
export function isDateRangeInvalid(fromDate: string, toDate: string): boolean {
  return toDate < fromDate
}

/**
 * Check if a YYYY-MM date string is valid (has both year and month selected)
 */
export function isMonthDateValid(dateString: string): boolean {
  const parts = dateString.split('-')
  if (parts.length < 2) return false

  const year = parseInt(parts[0], 10)
  const month = parseInt(parts[1], 10)

  return year > 0 && month > 0 && month <= 12
}
